module.exports = __webpack_public_path__ + "img/whatsappblackwhite.c1f7b70c.svg";